import Sidebar from "../../Components/Sidebar";
import ConversationsTable from "../../Components/Table/ConversationsTable";
import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import { Input } from "antd";
import { getConversations, getConversationStats } from "../../redux/actions/conversationAction";
import overview from "../../assest/dashboard b.png";
import targetgroup from "../../assest/2.png";
import targetuser from "../../assest/dashboard a.png";
import Button from "react-bootstrap/Button";
import { IoReorderThree } from "react-icons/io5";
import "../../styles/pages/conversations.css";

const Conversations = () => {
  const { Search } = Input;
  const [show, setShow] = useState(false);
  const handleShow = () => setShow(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        let organizationid = localStorage.getItem("organizationid");
        let payload = { organizationid };
        await getConversations(payload);
        await getConversationStats(payload);
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const allConversations = useSelector(
    (state) => state?.conversationReducer?.AllConversations
  );

  const conversationStats = useSelector(
    (state) => state?.conversationReducer?.ConversationStats
  );

  return (
    <div className='dashboard'>
      <Sidebar show={show} setShow={setShow} />
      <div className='dashboard-right-side'>
        <div className='headerbox'>
          <div className='d-flex gap-2 align-items-center'>
            <Button
              className='d-block d-lg-none bg-transparent text-dark border border-0'
              onClick={handleShow}
            >
              <IoReorderThree size={30} />
            </Button>
            <div className='headertext'>Conversations</div>
          </div>
        </div>

        <div className='row mt-3'>
          <div className='col-sm-12 col-md-6 col-lg-4 mb-4'>
            <div className='d-flex justify-content-between pt-4 statsbox px-3'>
              <div className='statsheading'>
                <p className='statSize mb-1 text-muted'>Total Conversations</p>
                <h1 className='mb-0'>{conversationStats?.totalConversations || 0}</h1>
              </div>
              <div className='text-end'>
                <img className='statsimg' src={overview} alt='' />
              </div>
            </div>
          </div>
          <div className='col-sm-12 col-md-6 col-lg-4 mb-4'>
            <div className='d-flex justify-content-between pt-4 statsbox px-3'>
              <div className='statsheading'>
                <p className='statSize mb-1 text-muted'>Active</p>
                <h1 className='mb-0'>{conversationStats?.activeCount || 0}</h1>
              </div>
              <div className='text-end'>
                <img className='statsimg' src={targetgroup} alt='' />
              </div>
            </div>
          </div>
          <div className='col-sm-12 col-md-6 col-lg-4 mb-4'>
            <div className='d-flex justify-content-between pt-4 pb-5 statsbox px-3'>
              <div className='statsheading'>
                <p className='statSize mb-1 text-muted'>Data Extracted</p>
                <h1 className='mb-0'>{conversationStats?.totalExtractedDataItems || 0}</h1>
              </div>
              <div className='text-end'>
                <img className='statsimg' src={targetuser} alt='' />
              </div>
            </div>
          </div>
        </div>

        <div className='phisingcampaigns'>
          <p>SMS Conversations</p>

          <div style={{ justifyContent: "end" }} className='mainheadingdiv'>
            <div className='searchbox' style={{ paddingLeft: "12px" }}>
              <Search
                placeholder='Search conversations...'
                enterButton
                className='h-[41px] [&>span>input]:h-[41px] [&_.ant-btn]:h-[41px] [&_.ant-btn]:flex [&_.ant-btn]:items-center'
              />
            </div>
          </div>

          <ConversationsTable conversations={allConversations} />
        </div>
      </div>
    </div>
  );
};

export default Conversations;
